import React, {Component} from 'react';

import Header from '../decoration/header';
import OrderPageProgressBar from '../decoration/orderPageProgressBar';
import Footer from '../footer/footer';
import tick from './img/Group_2.png';
import {Link} from "react-router-dom";

import './orderPage4.css';

class OrderPage4 extends Component {
  render() {
    return(
      <div className="OrderPage4">
        <Header />
        <OrderPageProgressBar index="4" />

          <div className={"order_complete_content"}>

              <div className={"order_complete_content_header"}>
                  Congratulations!
              </div>

              <div className={"order_complete_img_box"}>
                  <img className={"order_complete_img"} src={tick} alt="orderCompleteImg" />
              </div>

              <div className={"order_complete_success"}>
                  You order is successfully submitted
              </div>

              <div className={"order_complete_note"}>
                  Please note that your order is not finalized. Our staff will contact you soon to confirm your order.
              </div>

              <div className={"order_complete_button"}>
                  <Link className={"white_color"} to="/"> BACK TO THE SHOP</Link>
              </div>

          </div>

        <Footer />
      </div>
    );
  }
}

export default OrderPage4;



// WEBPACK FOOTER //
// ./src/components/orderPage4/orderPage4.js